import React, { Component } from 'react';

import InputBox from '../../../../etc/InputBox';
import SelectBox from '../../../../etc/SelectBox';

class ReviewItem extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  onChange = (e) => {
    console.log(e);
  };
  
  render() {
    return (
      <>
        <div className="card col-md-12">
          <div className="card-header">
            논문 후기
          </div>
          <div className="card-body">
            <div className="row mb-2">
              <div className="col-md-6">
                <InputBox
                  title="작성자"
                  value={[{ value : "최일식 [2019232]" }]}
                />
              </div>
              <div className="col-md-6">
                <InputBox
                  title="작성일자"
                  value={[{ value : "2021-07-05" }]}
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-6">
                <InputBox
                  title="저자역활"
                  value={[{ value : "교신저자" }]}
                />
              </div>
              <div className="col-md-6 form-group">
                <label htmlFor=""><strong>상태</strong></label>
                <SelectBox 
                  OptionData={[
                    { "value" : 1, "name": "전체공개" },
                    { "value" : 2, "name": "학내공개" },
                    { "value" : 3, "name": "비공개" },
                  ]}
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-12 form-group">
                <label htmlFor="journal_title"><strong>내용</strong></label>
                <textarea className="form-control" placeholder="" id=""></textarea>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default ReviewItem;